import React, { useEffect } from 'react';
import { Layout } from 'tea-component';
import CardCommon from '../../components/CardCommon';
import { connect } from 'umi';
import { useGameOperations } from '@op/utils/game';
import './index.scss';
const { Content } = Layout;
function NoPermission({ wholeGameInfo }: { wholeGameInfo: any }) {
  const { handleChangeGame } = useGameOperations();

  useEffect(() => {
    if (wholeGameInfo.opinion_permissions) {
      handleChangeGame(wholeGameInfo, true);
    }
  }, [wholeGameInfo]);
  return (
    <Content className="dbo-page no-permission-wrapper">
      <Content.Body>
        <CardCommon
          emptyHeight={760}
          empty
          hasEmptyTitle={false}
          emptyDescText={
            'You are unable to view the game data currently, please feel free to contact {contact} for permissions.'
          }
        ></CardCommon>
      </Content.Body>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(NoPermission);
